module.exports = __webpack_public_path__ + "assets/img/more-btn-dd0d2a62.png";